import { EnvService } from './env.service';

export const envServiceFactory = () => {
  // Create env
  const env = new EnvService();

  // Read environment variables from browser window
  const browserWindow = window || {};
  type ObjectKey = keyof typeof browserWindow;
  const envKey = '__env' as ObjectKey;
  const browserWindowEnv: { [id: string]: string } = browserWindow[envKey] || {};

  // Assign environment variables from browser window to env
  // In the current implementation, properties from env.js overwrite defaults from the EnvService.
  // If needed, a deep merge can be performed here to merge properties instead of overwriting them.
  for (const key in browserWindowEnv) {
    if (browserWindowEnv.hasOwnProperty(key)) {
      env.setEnvValue(key, browserWindowEnv[key]);
    }
  }

  return env;
};

export const envServiceProvider = {
  provide: EnvService,
  useFactory: envServiceFactory,
  deps: [],
};
